// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RelayRuntime = require("relay-runtime");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");
let MySharedPostsListPaginationQuery_graphql = require("./MySharedPostsListPaginationQuery_graphql.bs.js");

let Types = {};

function unwrap_fragment_sharedPostsForCurrentUserV5_edges_node(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["SharedPropertyV5"]);
}

let fragmentConverter = {"__root":{"sharedPostsForCurrentUserV5_edges_node_SharedPropertyV5":{"f":""},"sharedPostsForCurrentUserV5_edges_node":{"u":"fragment_sharedPostsForCurrentUserV5_edges_node"}}};

let fragmentConverterMap = {
  fragment_sharedPostsForCurrentUserV5_edges_node: unwrap_fragment_sharedPostsForCurrentUserV5_edges_node
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function makeConnectionId(connectionParentDataId) {
  return RelayRuntime.ConnectionHandler.getConnectionID(connectionParentDataId, "MySharedPostsList_query_sharedPostsForCurrentUserV5", undefined);
}

function getConnectionNodes(connection) {
  if (connection === undefined) {
    return [];
  }
  let edges = connection.edges;
  if (edges !== undefined) {
    return Stdlib_Array.filterMap(edges, edge => {
      if (edge !== undefined) {
        return edge.node;
      }
    });
  } else {
    return [];
  }
}

let Utils = {
  getConnectionNodes: getConnectionNodes
};

function makeNode(rescript_graphql_node_MySharedPostsListPaginationQuery) {
  return ((function(){
var v0 = [
  "sharedPostsForCurrentUserV5"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "viewId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": rescript_graphql_node_MySharedPostsListPaginationQuery
    }
  },
  "name": "MySharedPostsWidgetList_query",
  "selections": [
    {
      "alias": "sharedPostsForCurrentUserV5",
      "args": [
        {
          "kind": "Variable",
          "name": "__dynamicKey",
          "variableName": "viewId"
        }
      ],
      "concreteType": "QuerySharedPostsForCurrentUserV5Connection",
      "kind": "LinkedField",
      "name": "__MySharedPostsList_query_sharedPostsForCurrentUserV5_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QuerySharedPostsForCurrentUserV5ConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "databaseId",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "MySharedPostsWidgetListItemSharedProperty_sharedProperty"
                    }
                  ],
                  "type": "SharedPropertyV5",
                  "abstractKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})());
}

let node = makeNode(MySharedPostsListPaginationQuery_graphql.node);

let wrap_fragment_sharedPostsForCurrentUserV5_edges_node = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_sharedPostsForCurrentUserV5_edges_node = unwrap_fragment_sharedPostsForCurrentUserV5_edges_node;
exports.wrap_fragment_sharedPostsForCurrentUserV5_edges_node = wrap_fragment_sharedPostsForCurrentUserV5_edges_node;
exports.Internal = Internal;
exports.makeConnectionId = makeConnectionId;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
